import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { firestore } from "../../firebase/config";
import { useSessionStorage } from "../../logic/useSessionStorage";
import { useParams } from "react-router-dom";
import Select from "react-select";
import { useForm } from "react-hook-form";
import GoBackButton from "../../components/FormComponents/GoBackButton";
import { useNavigate } from "react-router-dom";
import { updateContentCellarStep } from "../../firebase/cellarSteps";
import { doc, onSnapshot } from 'firebase/firestore';

const CellarStepContentDetail = () => {
    const validationTypes = ["notEmpty", "null"];
    const validation1Types = ["greaterThen", "lesserThen", 'null'];
    const typeOptions = [
        "geopoint",
        "multilinetext",
        "image",
        "label",
        "option",
        "decimal",
        "text",
        "timestamp",
        'section'
    ];
    const [currentWinery, setCurrentWinery] = useSessionStorage(
        "currentwinery",
        ""
    );
    const params = useParams();
    const formClassname = "ui big form twelve wide column ";
    const { register, handleSubmit } = useForm();
    const navigate = useNavigate();

    const [currentCellarStep, setCurrentCellarStep] = useState("");
    const [currentStepContent, setCurrentStepContent] = useState("");
    const [selectedType, setSelectedType] = useState([]);
    const [selectedValidation, setSelectedValidation] = useState([]);
    const [selectedValidation1, setSelectedValidation1] = useState([]);
    const [selectedValidation2, setSelectedValidation2] = useState([]);
    const [error, setError] = useState("hidden");
    const [isLoading, setIsLoading] = useState(true);
    const { t } = useTranslation();

    let currentStep;
    let currentContent;

    useEffect(() => {
        setIsLoading(true);
        const cellarStepDocRef = doc(firestore, 'winegrowers', currentWinery, 'cellarSteps', params.id);
        
        const unsubscribe = onSnapshot(cellarStepDocRef, (doc) => {
            if (doc.exists) {
                currentStep = doc.data();
            }
            currentContent = currentStep.content.find(
                (s) => s.order == params.stepnumber
            );
            setCurrentCellarStep(currentStep);
            setCurrentStepContent(currentContent);
        });
        setIsLoading(false);

        return () => {
            unsubscribe();
        };
    }, []);

    const handleTypeChange = (selection, action) => {
        setSelectedType(selection.value);
    };

    const handleValidation1Change = (selection, action) => {
        setSelectedValidation1(selection.value);
    };

    const handleValidation2Change = (selection, action) => {
        setSelectedValidation2(selection.value);
    };

    const handleValidationChange = (selection, action) => {
        setSelectedValidation(selection.value);
    }

    const onSubmit = async (data) => {
        try {
            setError("hidden");
            const newDoc = generateNewCellarStep(data);
            await updateContentCellarStep(currentWinery, params.id, newDoc);
            navigate(-1);
        } catch (error) {
            console.error(error);
        }
    }

    function generateNewCellarStep(data) {
        var newDoc;
        if (selectedType == "") {
            data.type = currentStepContent["type"];
        }
        if (selectedValidation1 == "") {
            data.validation1 = currentStepContent["validation1"];
        }
        if (selectedValidation2 == "") {
            data.validation2 = currentStepContent["validation2"];
        }

        data["order"] = Number(data["order"]);

        if (data["validation"] === "") {
            data["validation"] = null;
        }
        if (data["validationValue"] === "") {
            data["validationValue"] = null;
        }
        if (data["validation1"] === "") {
            data["validation1"] = null;
        }
        if (data["validation1Value"] === "") {
            data["validation1Value"] = null;
        } else {
            data["validation1Value"] = Number(data["validation1Value"]);
        }
        if (data["validation2"] === "") {
            data["validation2"] = null;
        }
        if (data["validation2Value"] === "") {
            data["validation2Value"] = null;
        } else {
            data['validation2Value'] = Number(data["validation2Value"]);
        }

        newDoc = { ...currentCellarStep };
        const index = currentCellarStep.content
            .map((x) => x.key)
            .indexOf(data["key"]);
        newDoc.content[index] = data;
        return newDoc;
    }

    function generateUserForm() {
        var form = [];
        if (currentStepContent !== undefined) {
            const sortedContent = Object.keys(currentStepContent)
                .sort()
                .reduce((accumulator, key) => {
                    accumulator[key] = currentStepContent[key];
                    return accumulator;
                }, {});

            for (const [key, value] of Object.entries(sortedContent)) {
                if (key === "key") {
                    form.push(
                        <div
                            className="fields"
                            style={{ justifyContent: "center", marginTop: "20px" }}
                        >
                            <div className="twelve wide field">
                                <label>
                                    {t(`translation.vineyardSteps.${key}`)}
                                    <input
                                        type="text"
                                        {...register(key)}
                                        htmlFor={key}
                                        defaultValue={value}
                                        style={{ textAlign: "center" }}
                                        readOnly />
                                </label>
                            </div>
                        </div>
                    );
                } else if (key === "order") {
                    form.push(
                        <div
                            className="fields"
                            style={{ justifyContent: "center", marginTop: "20px" }}
                        >
                            <div className="twelve wide field">
                                <label>
                                    {t(`translation.vineyardSteps.${key}`)}
                                    <input
                                        type="number"
                                        {...register(key)}
                                        htmlFor={key}
                                        required="required"
                                        defaultValue={value}
                                        style={{ textAlign: "center" }} />
                                </label>
                            </div>
                        </div>
                    );
                } else if (key === "type") {
                    form.push(
                        <div
                            className="fields"
                            style={{ justifyContent: "center", marginTop: "20px" }}
                        >
                            <div className="twelve wide field">
                                <label>
                                    {t(`translation.vineyardSteps.${key}`)}

                                    <Select
                                        label={key}
                                        htmlFor={key}
                                        onChange={(selection, action) =>
                                            handleTypeChange(selection, action)
                                        }
                                        options={typeOptions.map((value) => ({
                                            label: value,
                                            value: value,
                                        }))}
                                        defaultValue={{
                                            label: value,
                                            value: value,
                                        }}
                                    ></Select>
                                </label>
                                <div style={{ display: "none" }}>
                                    <input
                                        {...register(key)}
                                        htmlFor={key}
                                        value={selectedType}
                                        defaultValue={selectedType}
                                        readOnly />
                                </div>
                            </div>
                        </div>
                    );
                } else if (key === "validation1") {
                    form.push(
                        <div
                            className="fields"
                            style={{ justifyContent: "center", marginTop: "20px" }}
                        >
                            <div className="twelve wide field">
                                <label>
                                    {t(`translation.vineyardSteps.${key}`)}

                                    <Select
                                        label={key}
                                        htmlFor={key}
                                        onChange={(selection, action) =>
                                            handleValidation1Change(selection, action)
                                        }
                                        options={validation1Types.map((value) => ({
                                            label: value,
                                            value: value,
                                        }))}
                                        defaultValue={{
                                            label: value,
                                            value: value,
                                        }}
                                    ></Select>
                                </label>
                                <div style={{ display: "none" }}>
                                    <input
                                        {...register(key)}
                                        htmlFor={key}
                                        value={selectedValidation1}
                                        defaultValue={selectedValidation1}
                                        readOnly />
                                </div>
                            </div>
                        </div>
                    );
                } else if (key === "validation2") {
                    form.push(
                        <div
                            className="fields"
                            style={{ justifyContent: "center", marginTop: "20px" }}
                        >
                            <div className="twelve wide field">
                                <label>
                                    {t(`translation.vineyardSteps.${key}`)}

                                    <Select
                                        label={key}
                                        htmlFor={key}
                                        onChange={(selection, action) =>
                                            handleValidation2Change(selection, action)
                                        }
                                        options={validation1Types.map((value) => ({
                                            label: value,
                                            value: value,
                                        }))}
                                        defaultValue={{
                                            label: value,
                                            value: value,
                                        }}
                                    />
                                </label>
                                <div style={{ display: "none" }}>
                                    <input
                                        {...register(key)}
                                        htmlFor={key}
                                        value={selectedValidation2}
                                        defaultValue={selectedValidation2}
                                        readOnly />
                                </div>
                            </div>
                        </div>
                    );
                } else if (key === "validation") {
                    form.push(
                        <div className='fields'
                            style={{ justifyContent: "center", marginTop: "20px" }}
                        >
                            <div className='twelve wide field'>
                                <label>
                                    {t(`translation.vineyardSteps.${key}`)}

                                    <Select
                                        label={key}
                                        htmlFor={key}
                                        onChange={(selection, action) => {
                                            handleValidationChange(selection, action);
                                        }}
                                        options={validationTypes.map((value) => ({
                                            label: value,
                                            value: value
                                        }))}
                                    />
                                </label>
                                <div style={{ display: "none" }}>
                                    <input
                                        {...register(key)}
                                        htmlFor={key}
                                        value={selectedValidation}
                                        defaultValue={selectedValidation}
                                        readOnly />
                                </div>
                            </div>
                        </div>
                    )
                } else {
                    form.push(
                        <div
                            className="fields"
                            style={{ justifyContent: "center", marginTop: "20px" }}
                        >
                            <div className="twelve wide field">
                                <label>
                                    {t(`translation.vineyardSteps.${key}`)}
                                    <input
                                        type="text"
                                        {...register(key)}
                                        htmlFor={key}
                                        defaultValue={value}
                                        style={{ textAlign: "center" }} />
                                </label>
                            </div>
                        </div>
                    );
                }
            }
        }
        return form;
    }

    return (
        <div>
            <div
                className="add-form-class"
                style={{
                    maxWidth: 960,
                    margin: "50px auto",
                    marginTop: "110px",
                }}
            >
                <h1 style={{ color: "#7f7f7f" }}> {t('translation.vineyardSteps.vineyardStepInfo')} </h1>
                <GoBackButton />
                <div
                    className="ui grid stackable"
                    style={{ justifyContent: "center", marginTop: "-90px" }}
                >
                    <form
                        className={formClassname}
                        style={{
                            border: "3px solid #B3B3B3",
                            marginTop: "100px",
                            borderRadius: "50px",
                            background: "#edeaea",
                            borderColor: "#ac9e66",
                        }}
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        {!isLoading && generateUserForm()}
                        <p style={{ visibility: error }} className="text-danger"> {t('translation.vineyardSteps.stepTypeNotSelected')} </p>
                        <button
                            type="submit"
                            className="ui submit large grey button right floated  button-vinyards"
                            style={{ float: "none", width: "25%" }}
                        >
                             {t('translation.cellarSteps.updateCellarStep')}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};
export default CellarStepContentDetail;